module.exports = __webpack_public_path__ + "media/images/next-62074ac7.png";